export default __webpack_public_path__ + "static/edumine-88bcee3c3bd6357f06e064a204ea508b.png";